module.exports = __webpack_public_path__ + "assets/img/9f28131609a989777bc06545455f17b9.png";